module.exports = __webpack_public_path__ + "static/media/skipped-cross.9d42f603.svg";